import loadScript from 'load-script';
//import {GOOGLE_RECAPTCHA_SITE_KEY} from '../../../config';
export default function google(GOOGLE_RECAPTCHA_SITE_KEY,callback) {
  loadScript(`https://www.google.com/recaptcha/api.js?render=${GOOGLE_RECAPTCHA_SITE_KEY}`, { async: true },(err)=>{
    if(err) return console.log("Can't load google recaptcha");
    callback();
  });
}
